import { Button, Modal } from 'antd';
import { t } from 'i18next';
import parse from 'html-react-parser';
import IconDelete from '../../../assets/Images/icons/icon-delete';

const ModalDelete = ({
    open,
    text = t('common.ConfirmDeleteText'),
    handelClose,
    handelOk,
    loading,
    centered = false,
    title = t('common.ConfirmDelete'),
}) => {
    return (
        <Modal
            centered={centered}
            width={450}
            className="_modal"
            footer={false}
            open={open}
            onCancel={handelClose}
        >
            <div className="flex flex-col space-y-4 justify-center items-center py-6 text-center">
                <IconDelete />
                <div className="text-2xl font-semibold whitespace-pre-line">
                    {title}
                </div>
                <div className={`whitespace-pre-line text-[#65707A]`}>
                    {parse(text)}
                </div>
            </div>
            <div className="flex justify-center items-center space-x-4">
                <Button
                    type="primary"
                    onClick={handelClose}
                    size="large"
                    ghost
                    className="w-36"
                >
                    {t('common.Cancel')}
                </Button>
                <Button
                    danger
                    loading={loading}
                    onClick={handelOk}
                    size="large"
                    type="primary"
                    className="w-36"
                >
                    {t('common.Confirm')}
                </Button>
            </div>
        </Modal>
    );
};
export default ModalDelete;
